import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getAsset } from '../../../../../../../../util/assets';
import Button from '../../../../../../../../components/global/Button';

const propTypes = {
  className: PropTypes.string,
  albumMembershipPhoto: PropTypes.shape({
    photo: PropTypes.shape({
      id: PropTypes.string,
    }),
    album: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
  cartItem: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  remainingItems: PropTypes.number,
  onConfigurationComplete: PropTypes.func,
  onDigitalDownloadToggle: PropTypes.func.isRequired,
};

const DigitalDownloadOption = ({
  className,
  albumMembershipPhoto,
  cartItem,
  remainingItems,
  onConfigurationComplete,
  onDigitalDownloadToggle,
}) => {
  const { photo, album } = albumMembershipPhoto ?? {};
  const buttonLabel = (() => {
    if (photo && photo?.is_entitled_matched_photo) {
      return 'Photo already purchased';
    }

    if (cartItem) {
      return 'Added to cart';
    }

    return 'Select photo';
  })();

  const classes = classNames({
    [className]: !!className,
    'purchases-pending-configuration-option-item': true,
    'purchases-pending-configuration-option-item-print-product': true,
    'is-selected': !!cartItem,
  });

  return (
    <div className={classes}>
      <div className="purchases-pending-configuration-option-item-thumb">
        <img
          src={getAsset('/digital-download-illustration.svg')}
          width="62px"
          alt=""
        />
      </div>
      <div className="purchasing-option-item-content-wrap">
        <span className="purchasing-option-item-title">
          Digital Download{' '}
          <span className="text-xs text-light text-bold">
            ({remainingItems} remaining)
          </span>
        </span>
        <Button
          pill
          btnSize="sm"
          btnOutline={!cartItem && !photo?.is_entitled_matched_photo}
          disabled={!!cartItem || photo?.is_entitled_matched_photo}
          className="text-bold"
          onClick={() => {
            onDigitalDownloadToggle({
              album,
              photo,
            });
            onConfigurationComplete?.();
          }}
        >
          {buttonLabel}
        </Button>
      </div>
    </div>
  );
};

DigitalDownloadOption.propTypes = propTypes;

export default DigitalDownloadOption;
